const FilterAgenda = {};
let current_agenda_filter = [];

function selectCustomOption( $option ) {

	const $input = $( '.js-filter-agenda .custom-select-input' ),
		val = $option.data( 'value' ),
		txt = $option.text();

	$option.addClass( 'is-selected' ).siblings( 'li' ).removeClass( 'is-selected' );
	$input.removeClass( 'is-active' ).children( 'span.txt' ).text( txt ).attr( 'data-value', val );
}

function doFiltering( val ) {

	var formData = {'filter':[]},
		urlFilters = '';
	current_agenda_filter['filters'] = [];

	if ( val != 0 ) {
		// console.log(1);
		current_agenda_filter['filters'][ current_agenda_filter['filters'].length ] = val;

		urlFilters = '?month=' + encodeURIComponent( current_agenda_filter['filters'] );
		var url = document.location.protocol + '//' + document.location.hostname + document.location.pathname;
		// console.log(url);
		// remove pagination from url otherwise filter won't work
		if (document.location.pathname.indexOf("page") !== -1) {
			var urlVars = url.split("/");
			urlVars.pop();
			urlVars.pop();
			urlVars.pop();
			url= urlVars.join("/");
		}
		// window.history.replaceState( {} , document.title, url + urlFilters );
	} else {
		urlFilters = '';
		var url = document.location.protocol + '//' + document.location.hostname + document.location.pathname;
		// window.history.replaceState( {} , document.title, url + urlFilters );
	}

	console.log('redirecting to: ' + url + urlFilters);
	window.location.href = url + urlFilters;
	// window.location.reload();
}

function resetFilter() {

	const txt = 'Filter op maand',
		val = 0;

	// input remove active class & option remove selected class
	$( '.js-filter-agenda .custom-select-input' ).removeClass( 'is-active' ).children( 'span.txt' ).text( txt ).attr( 'data-value', val );
	$( '.js-filter-agenda .custom-select-options li.is-selected' ).removeClass( 'is-selected' );

	var url = document.location.protocol + '//' + document.location.hostname + document.location.pathname;
	window.history.replaceState( {} , document.title, url );
	window.location.reload();
}

FilterAgenda.init = function() {

	$( '.js-reset-agenda-filter' ).on( 'click', function( e ) {
		e.preventDefault();
		resetFilter();
	} );

	$( '.js-filter-agenda .custom-select-input' ).on( 'click', function( e ) {
		e.preventDefault();
		const $this = $(this);
		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
		} else {
			$this.addClass( 'is-active' );
		}
	} );

	// desktop:
	if ( $( '.js-filter-agenda .custom-select-options li.is-selected' ).length > 0 ) {
		const $option = $( '.js-filter-agenda .custom-select-options li.is-selected' )
		selectCustomOption( $option );
	}

	$( '.js-filter-agenda .custom-select-options li' ).on( 'click', function( e ) {
		e.preventDefault();
		const $option = $(this);
		selectCustomOption( $option );
		doFiltering( $option.data( 'value' ) );
	} );

	// mobile
	$( '.js-filter-agenda select' ).on( 'change', function( e ) {
		e.preventDefault();
		const val = $( this ).find(':selected').data('value');
		doFiltering( val );
	} );

};

export { FilterAgenda };
